import axios from "axios"

const TRK: any = process.env.REACT_APP_BASE_URL_LOGIN

export interface LoginRequest {
    user: string
    password: string
}

export interface LoginResponse {
    token: string
    login: string
    conta: string
    status: string
}

export interface LoginError {
    message: string
    code?: string
    status?: number
}

class LoginService {
    async login(credentials: LoginRequest): Promise<LoginResponse> {
        try {
            const response = await axios.post<LoginResponse>(TRK, credentials, {
                headers: {
                    "Content-Type": "application/json"
                }
            })

            return response.data
        } catch (error: any) {
            this.handleError(error)
        }
    }

    private handleError(error: any): never {
        if (error.response) {
            const errorData = error.response.data
            const errorMessage = errorData?.message || "Credenciais inválidas"

            throw {
                message: errorMessage,
                code: errorData?.code,
                status: error.response.status
            } as LoginError
        } else if (error.request) {
            throw {
                message:
                    "Erro ao conectar com o servidor. Verifique sua conexão.",
                code: "NETWORK_ERROR"
            } as LoginError
        } else {
            // Outro tipo de erro
            throw {
                message: "Erro inesperado. Tente novamente.",
                code: "UNKNOWN_ERROR"
            } as LoginError
        }
    }

    isAuthenticated(): boolean {
        const token = localStorage.getItem("authToken")
        return !!token
    }

    saveAuthToken(token: string): void {
        localStorage.setItem("authToken", token)
    }

    logout(): void {
        localStorage.removeItem("authToken")
    }

    getAuthToken(): string | null {
        return localStorage.getItem("authToken")
    }
}

export const loginService = new LoginService()
export default loginService
